import { ReactElement, PropsWithChildren } from "react";
import { Card } from "@mantine/core";
import { ICustomCardProps } from "./types";
import { useStyles } from "./CustomCard.styled";

// data-testid
export default function CustomCard({
  borderColor,
  children,
  ...cardProps
}: PropsWithChildren<ICustomCardProps>): ReactElement {
  const { classes } = useStyles({ borderColor });

  return (
    <Card className={classes.root} w="100%" {...cardProps}>
      {children}
    </Card>
  );
}
